import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { createBeltContainer } from './BeltContainer';
import { BELT_CONTAINER_BASE_CLASSNAME } from './constants';
createComponents(".".concat(BELT_CONTAINER_BASE_CLASSNAME), createBeltContainer, NO_PATTERN_BUSINESS_LOGIC);
